import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface RegisterState {
  internalRegisterData: any
  registerError: any
}

export const useRegisterStore = defineStore('register', {
  state: (): RegisterState => ({
    internalRegisterData: null,
    registerError: null,
  }),

  getters: {
    getRegistrationData: (state) => state.internalRegisterData,
    getRegisterError: (state) => state.registerError,
  },

  actions: {
    async doRegisterUser(data: any) {
      try {
        this.internalRegisterData = null
        this.registerError = null
        const config = data instanceof FormData 
          ? { headers: { 'Content-Type': 'multipart/form-data' } } 
          : {}
        const response = await api().post('auth/api/auth/signup/staff', data, config)
        this.internalRegisterData = response.data
      } catch (error: any) {
        this.registerError = error.response?.data
      }
    },

    async doRegisterMda(data: any) {
      try {
        const response = await api().post('auth/api/auth/signup/mda', data)
        this.internalRegisterData = response.data
      } catch (error: any) {
        this.registerError = error.response?.data
      }
    },

    async doRegisterPartner(data: any) {
      try {
        const response = await api().post('auth/api/partners', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        this.internalRegisterData = response.data
      } catch (error: any) {
        this.registerError = error.response?.data
      }
    },
  },
})
